module.exports = __webpack_public_path__ + "static/media/avial.4a2cab5d.png";